export const bim = {
  addBim: "添加BIM",
  progressHelp: "文件必须处理后才能查看，此过程可能需要几分钟。",
};
